import { http } from "./http";

// 获取所有字典类型（公共接口，无需认证，只返回启用的数据）
export async function fetchDictTypesApiPublic() {
  return http.get(`/public/dicts/types`);
}

// 获取所有字典类型（需要认证，可获取所有数据包括未启用的）
export async function fetchDictTypesApi(params = {}) {
  const searchParams = new URLSearchParams();
  if (params.enabled !== undefined) searchParams.set("enabled", params.enabled);

  const query = searchParams.toString();
  return http.get(`/dicts/types${query ? `?${query}` : ""}`);
}

// 获取单个字典类型
export async function fetchDictTypeApi(id) {
  return http.get(`/dicts/types/${id}`);
}

// 创建字典类型
export async function createDictTypeApi(payload) {
  return http.post(`/dicts/types`, payload);
}

// 更新字典类型
export async function updateDictTypeApi({ id, ...payload }) {
  return http.put(`/dicts/types/${id}`, payload);
}

// 删除字典类型
export async function deleteDictTypeApi(id) {
  return http.delete(`/dicts/types/${id}`);
}

// 获取字典项列表
export async function fetchDictItemsApi(params = {}) {
  const searchParams = new URLSearchParams();
  if (params.typeId) searchParams.set("typeId", params.typeId);
  if (params.enabled !== undefined) searchParams.set("enabled", params.enabled);

  const query = searchParams.toString();
  return http.get(`/dicts/items${query ? `?${query}` : ""}`);
}

// 获取单个字典项
export async function fetchDictItemApi(id) {
  return http.get(`/dicts/items/${id}`);
}

// 创建字典项
export async function createDictItemApi(payload) {
  return http.post(`/dicts/items`, payload);
}

// 更新字典项
export async function updateDictItemApi({ id, ...payload }) {
  return http.put(`/dicts/items/${id}`, payload);
}

// 删除字典项
export async function deleteDictItemApi(id) {
  return http.delete(`/dicts/items/${id}`);
}

// 根据类型值获取字典项
export async function fetchDictItemsByTypeApi(typeValue) {
  return http.get(`/dicts/by-type/${typeValue}`);
}
